<template>

    <div>

        <div class="home-page-card card-wrap">

            <img class="card-img" src="../../../public/img/homepageImg.png" />

            <div class="inner-wrap">

                <h3>Skip the line</h3>
                <p :style="{ height: '55px' }">There is no need to wait anymore, pick up your order as soon as you arrive</p>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {

        name: 'user-dashboard',
        computed: {

            ...mapGetters({

                isAuth: 'auth/isAuth'
            })
        },
        methods: {

            redirect(){

                this.$router.push( { name: this.isAuth ? 'order-menu' : 'signin' } );
            }
        }
    }
</script>

<style scoped>

    .home-page-card {

        padding: 0px;
        max-width: 400px;
    }
    .card-img {

        width: 100%;
        max-height: 400px;
        min-height: 200px;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
    }
    .inner-wrap {

        padding-left: 10px;
    }
    button {

        margin: 20px 0px;
        height: 35px;
        border-radius: 15px;
    }

  @media screen and ( min-width: 420px ){

    .home-page-card {

        margin: 0px auto;
    }
  }
</style>